import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, Download, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const id = searchParams.get("id");
  const certificateId = searchParams.get("certificate");

  useEffect(() => {
    // Could trigger confetti or other celebration effect here
  }, []);

  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-forest-50 to-earth-50 flex items-center justify-center" data-testid="payment-success-page">
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="h-12 w-12 text-green-600" />
        </div>
        
        <h1 className="font-montserrat text-3xl font-bold text-slate-900 mb-4">
          Payment Successful!
        </h1>
        
        <p className="text-lg text-slate-600 mb-8">
          {type === "course" 
            ? "You have been successfully enrolled in the course. Check your email for access details."
            : "Thank you for your contribution to climate action! Your certificate is ready."
          }
        </p>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 mb-8">
          <p className="text-sm text-slate-500 mb-2">Reference ID</p>
          <p className="font-mono text-lg font-semibold text-slate-900">{id}</p>
          {certificateId && (
            <>
              <p className="text-sm text-slate-500 mt-4 mb-2">Certificate ID</p>
              <p className="font-mono text-lg font-semibold text-forest-700">{certificateId}</p>
            </>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {type === "contribution" && id && (
            <Link to={`/certificate/${id}`}>
              <Button className="bg-forest-950 hover:bg-forest-900" data-testid="view-certificate-btn">
                <Download className="mr-2 h-4 w-4" />
                View Certificate
              </Button>
            </Link>
          )}
          <Link to="/">
            <Button variant="outline" className="border-forest-950 text-forest-950 hover:bg-forest-50">
              Back to Home
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>

        <p className="text-sm text-slate-500 mt-8">
          A confirmation email has been sent to your registered email address.
        </p>
      </div>
    </div>
  );
}
